import { Tab, Tabs } from "@nulogy/components";
import ModalFormButtons from "components/controls/ModalFormButtons";
import CreateDowntimeBlockForm from "components/pages/schedule/downtimeBlocks/CreateDowntimeBlockForm";
import BlockModal from "components/pages/schedule/styles/BlockModal";
import CreateWorkBlockForm from "components/pages/schedule/workBlocks/CreateWorkBlockForm";
import React from "react";

const WORK_BLOCK_TAB = 0;
const DOWNTIME_TAB = 1;

export default function CreateBlockModalView({
  blockData,
  isOpen,
  onClose,
  onSave,
  tab,
  onTabClick,
  lines,
  workOrders,
  workBlockErrors,
  setWorkBlockErrors,
  downtimeErrors,
  setDowntimeErrors,
  applicationContext,
  workBlockModalUIState,
}) {
  const formId = tab === WORK_BLOCK_TAB ? "createWorkBlock" : "createDowntime";
  const pendoTagClass =
    tab === WORK_BLOCK_TAB ? "pendo-create-work-block-modal-save" : "pendo-create-downtime-modal-save";

  const hasWorkBlockErrors = tab === WORK_BLOCK_TAB && Object.keys(workBlockErrors).length > 0;
  const hasDowntimeErrors = tab === DOWNTIME_TAB && Object.keys(downtimeErrors).length > 0;
  const hasNoWorkOrders = tab === WORK_BLOCK_TAB && workOrders.length === 0;

  const disabled = hasWorkBlockErrors || hasDowntimeErrors || hasNoWorkOrders;

  return (
    <BlockModal
      className="spec-block-create-modal"
      footerContent={
        <ModalFormButtons disabled={disabled} formId={formId} onClose={onClose} pendoTagClass={pendoTagClass} />
      }
      isOpen={isOpen}
      onRequestClose={onClose}
      title="Create block"
    >
      <Tabs fitted onTabClick={onTabClick} selectedIndex={tab}>
        <Tab className="pendo-create-work-block-tab" label="Work block">
          <CreateWorkBlockForm
            applicationContext={applicationContext}
            blockData={blockData}
            errors={workBlockErrors}
            lines={lines}
            onClose={onClose}
            onSave={onSave}
            setErrors={setWorkBlockErrors}
            workBlockModalUIState={workBlockModalUIState}
            workOrders={workOrders}
          />
        </Tab>
        <Tab className="pendo-create-downtime-tab" label="Downtime block">
          <CreateDowntimeBlockForm
            blockData={blockData}
            errors={downtimeErrors}
            lines={lines}
            onClose={onClose}
            onSave={onSave}
            setErrors={setDowntimeErrors}
          />
        </Tab>
      </Tabs>
    </BlockModal>
  );
}
